import React from 'react';
import {useSettings} from '../../../store/slices/settings/settingsSlice';
import styles from './AnimatedBackground.module.scss'

export const AnimatedBackground: React.FC = () => {
    const {reducedMotion} = useSettings();
    if (reducedMotion) return null;
    return (
        <ul className={styles.background}>
            <li></li>
            <li></li>
            <li></li>
            <li></li>
            <li></li>
            <li></li>
            <li></li>
            <li></li>
            <li></li>
            <li></li>
        </ul>
    );
};
